// checking if an element is fully visible anywhere in port
export function isFullyVisibleIfUnderParent(el) {
  if (!el) return false;

  const rect = el.getBoundingClientRect();

  let parent = el.parentElement;

  while (parent) {
    const style = getComputedStyle(parent);
    const hasOverflow = /(auto|scroll|hidden)/.test(
        style.overflow + style.overflowX + style.overflowY
      );

    if (hasOverflow) {
      const parentRect = parent.getBoundingClientRect();

      if (
        rect.top < parentRect.top ||
        rect.left < parentRect.left ||
        rect.bottom > parentRect.bottom ||
        rect.right > parentRect.right
      ) {
        return false; // part of the popover is clipped by this parent
      }
    }

    parent = parent.parentElement;
  }

  return true; // fully visible in viewport and all overflow parents
}

// Lowercase extension of a file name, S3 key or URL ("" when there is none).
// Query string and hash are ignored, so presigned URLs resolve correctly.
export const getFileExtension = (path = "") => {
  const fileName = String(path).split(/[?#]/)[0].split("/").pop();
  return fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
};
